import React from "react";
import {
  TextField,
  Box,
  Typography,
  InputLabel,
  MenuItem,
  FormControl,
  FormLabel,
  Button,
  IconButton,
  Tooltip,
  Checkbox,
  LinearProgress,
  useMediaQuery,
  useTheme,
  Select,
  Paper,
  Breadcrumbs,
  Grid,
  Chip,
} from "@mui/material";
import Resizer from "react-image-file-resizer";
import store from "../../../index";
import {
  fileUpload,
  fnFileUpload,
  fnImageUpload,
  imageUpload,
} from "../../../store/reducers/Imguploadreducer";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import * as Yup from "yup";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { Field, Formik } from "formik";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import {
  postData,
  getFetchData,
  PartyBankget,
  partyBankpostData,
  PartyContactget,
  partyContactData,
  VendorRegisterpostData,
  VendorRegisterFetchData,
  VendorDefaultPUTdata,
  VendorDefaultFetchData,
  explorePostData,
} from "../../../store/reducers/Formapireducer";
import { useEffect, useState, useMemo } from "react";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { tokens } from "../../../Theme";
import { formGap } from "../../../ui-components/global/utils";
import {
  CheckinAutocomplete,
  OrderItemAutocomplete,
} from "../../../ui-components/global/Autocomplete";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import { GridToolbarQuickFilter } from "@mui/x-data-grid";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { dataGridHeaderFooterHeight, dataGridHeight, dataGridHeightExplore, dataGridRowHeight } from "../../../ui-components/utils";
import CircularProgress from "@mui/material/CircularProgress";
import { ArrowBack, CloudUpload } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";

const Editvendor = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  let params = useParams();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const location = useLocation();
  const isLoading = useSelector((state) => state.formApi.postLoading);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  // Redux state
  const [page, setPage] = React.useState(secondaryCurrentPage);
  const data = useSelector((state) => state.formApi.Data);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const state = location.state || {};
  const partyBankgetloading = useSelector(
    (state) => state.formApi.partyBankgetloading
  );
  const partyBankgetdata = useSelector(
    (state) => state.formApi.partyBankgetdata
  );
  const partyContactgetdata = useSelector(
    (state) => state.formApi.partyContactgetdata
  );
  const partyRegistergetdata = useSelector(
    (state) => state.formApi.vendorregisterGetData
  );
  const isPartyRegisterLoading = useSelector(
    (state) => state.formApi.vendorregisterGetDataloading
  );
  const partyDefaultgetdata = useSelector(
    (state) => state.formApi.vendorDefaultGetData
  );
  const isPartyDeaultLoading = useSelector(
    (state) => state.formApi.vendorDefaultGetDataloading
  );

  const YearFlag = sessionStorage.getItem("YearFlag");
  const Year = sessionStorage.getItem("year");
  const Finyear = sessionStorage.getItem("YearRecorid");
  const CompanyID = sessionStorage.getItem("compID");
  const CompanyAutoCode = sessionStorage.getItem("CompanyAutoCode");
  const LoginID = sessionStorage.getItem("loginrecordID");
   const SubscriptionCode = sessionStorage.getItem("SubscriptionCode") || "";
  const lastThree = SubscriptionCode?.slice(-3) || "";
  const Subscriptionlastthree = ["001", "002", "003", "004"].includes(lastThree)
    ? lastThree
    : "";
  const [panImage, setPanImage] = useState("");
  const [ID1Image, setID1Image] = useState("");
  const [ID2Image, setID2Image] = useState("");
  var secondaryCurrentPage = parseInt(
    sessionStorage.getItem("secondaryCurrentPage")
  );
  const [panUrl, setPanUrl] = useState(null);
  const [gstImage, setGstImage] = useState("");
  const [gstUrl, setGstUrl] = useState(null);
  console.log(panImage, "panImage");
  console.log(panImage.name, "panImage");
  console.log(gstImage, "gstImage");
  console.log(gstImage.name, "gstImage");
  const [show, setScreen] = React.useState("0");
  const recID = params.id;
  const mode = params.Mode;
  const accessID = params.accessID;
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);
  const [validationSchema2, setValidationSchema2] = useState(null);
  const [validationSchema3, setValidationSchema3] = useState(null);
  const [validationSchema4, setValidationSchema4] = useState(null);

  const [funMode, setFunMode] = useState("A");
  const [laomode, setLaoMode] = useState("A");
  const colors = tokens(theme.palette.mode);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);

        let schemaFields = {
          name: Yup.string().trim().required(data.Party.name),

          mobilenumber: Yup.string()
            .required(data.Party.mobilenumber)
            // .matches(/^[6-9]\d{9}$/, "Invalid Mobile Number"),
            .matches(/^(\d{10,11})$/, "Enter a valid Mobile or Landline Number"),

          emailid: Yup.string()
            .nullable()
            .notRequired()
            .trim()
            .test(
              "email-or-empty",
              "Invalid Email ID",
              (value) => !value || Yup.string().email().isValidSync(value)
            ),
        };
        // locality: Yup.object().required(data.Party.locality).nullable(),
        //ReferenceBy: Yup.object().required(data.Party.ReferenceBy).nullable(),
        if (CompanyAutoCode === "N") {
          schemaFields.code = Yup.string().required(data.Party.code);
        }

        // schemaFields.Pancardnumber = Yup.string()
        //   .nullable()
        //   .notRequired()
        //   .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, data.Party.Pancardnumber)
        //   .transform((value) => (value === "" ? null : value));

        // schemaFields.gstnumber = Yup.string()
        //   .nullable()
        //   .notRequired()
        //   .matches(
        //     /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        //     data.Party.gstnumber
        //   )
        //   .transform((value) => (value === "" ? null : value));

        const schema = Yup.object().shape(schemaFields);
        const schema2 = Yup.object().shape({
          bankname: Yup.string().trim().required(data.BankDetails.bankname),
          branchname: Yup.string().trim().required(data.BankDetails.branchname),
          Accounttype: Yup.string().trim().required(data.BankDetails.Accounttype),
          ifsc: Yup.string()
            .required(data.BankDetails.ifsc)
            .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC Code"),
          accountnumber: Yup.string()
            .required(data.BankDetails.accountnumber)
            .matches(/^\d{9,18}$/, "Invalid Account Number"),
          bankloc: Yup.string().trim().required(data.BankDetails.bankloc),
          accountholdname: Yup.string().trim().required(
            data.BankDetails.accountholdname
          ),
          bankaddress: Yup.string().trim().required(data.BankDetails.bankaddress),
        });
        const schema3 = Yup.object().shape({
          name1: Yup.string().trim().required(data.Contactdetails.name1),
          emailid1: Yup.string()
            .email("Invalid Email ID")
            .required(data.Contactdetails.emailid1),
          mobileno1: Yup.string()
            .matches(/^[0-9]{10}$/, "Invalid Mobile Number")
            .required(data.Contactdetails.mobileno1),
          aadharcardnumber2: Yup.string()
            .nullable()
            .notRequired()
            .transform((value) => (value === "" ? null : value))
            .matches(/^\d{12}$/, data.Contactdetails.aadharcardnumber2),
          aadharcardnumber1: Yup.string()
            .nullable()
            .notRequired()
            .transform((value) => (value === "" ? null : value))
            .matches(/^\d{12}$/, data.Contactdetails.aadharcardnumber1),
        });
        const schema4 = Yup.object().shape({
          Pancardnumber: Yup.string()
            .nullable()
            .notRequired()
            .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, data.Party.Pancardnumber)
            .transform((value) => (value === "" ? null : value)),

          gstnumber: Yup.string()
            .nullable()
            .notRequired()
            .matches(
              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
              data.Party.gstnumber
            )
            .transform((value) => (value === "" ? null : value)),
        });

        setValidationSchema(schema);
        setValidationSchema2(schema2);
        setValidationSchema3(schema3);
        setValidationSchema4(schema4);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, [CompanyAutoCode]);

  // useEffect(() => {
  //   if (recID && mode === "E") {
  //     dispatch(getFetchData({ accessID: "TR243", get: "get", recID }));
  //   } else {
  //     dispatch(getFetchData({ accessID: "TR243", get: "get", recID }));
  //   }
  // }, [location.key, recID, mode]);
  useEffect(() => {
    if (show == "0") {
      if (recID && mode === "E") {
        dispatch(getFetchData({ accessID: "TR243", get: "get", recID }));
      } else {
        dispatch(getFetchData({ accessID: "TR243", get: "get", recID }));
      }
    }
  }, [location.key, recID, mode, show]);

  const explorelistViewData = useSelector(
    (state) => state.exploreApi.explorerowData
  );
  const explorelistViewcolumn = useSelector(
    (state) => state.exploreApi.explorecolumnData
  );
  const exploreLoading = useSelector((state) => state.exploreApi.loading);

  // let VISIBLE_FIELDS;

  // if (show == "5") {
  //   VISIBLE_FIELDS = [
  //     "slno",
  //     "NextRenewalRequiredDate",
  //     "Description",
  //     "Category",
  //     "action",
  //   ];
  // }
  const VISIBLE_FIELDS =
    show == "5"
      ? [
        "slno",
        "Code",
        "Documents",
        // "Party",
        // "Unit",
        "action",
      ]
      : [];
  const columns = React.useMemo(() => {
    let visibleColumns = explorelistViewcolumn.filter((column) =>
      VISIBLE_FIELDS.includes(column.field)
    );

    if (VISIBLE_FIELDS.includes("slno")) {
      const slnoColumn = {
        field: "slno",
        headerName: "SL#",
        width: 50,
        sortable: false,
        filterable: false,
        // valueGetter: (params) =>
        //   page * pageSize +
        //   params.api.getRowIndexRelativeToVisibleRows(params.id) +
        //   1,
        renderCell: (params) => params.row.SLNO,

      };
      visibleColumns = [slnoColumn, ...visibleColumns];
    }

    return visibleColumns;
  }, [explorelistViewcolumn, VISIBLE_FIELDS]);
  const [rowCount, setRowCount] = useState(0);
  const [uploadFile, setUploadFile] = useState();
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState();

  const [empLoaData, SetEmpLoaData] = useState({
    recordID: "",
    description: "",
    category: "",
    RenewalDate: "",
    personal: false,
    renewal: false,
    Attachment: "",
  });
  if (!data && getLoading) {
    return <LinearProgress />;
  }

  const contactvalidationSchema = Yup.object().shape({
    name1: Yup.string().required("Name is required"),
    emailid1: Yup.string()
      .email("Invalid email format")
      .required("Email ID is required"),
    mobileno1: Yup.string()
      .matches(/^[0-9]{10}$/, "Mobile No must be 10 digits")
      .required("Mobile No is required"),
    // name2: Yup.string().required('Name is required'),
    // emailid2: Yup.string()
    //   .email('Invalid email format')
    //   .required('Email ID is required'),
    // mobileno2: Yup.string()
    //   .matches(/^[0-9]{10}$/, 'Mobile No must be 10 digits')
    //   .required('Mobile No is required'),
  });
  const getFileID1Change = async (e) => {
    let files = e.target.files;
    let fileReader = new FileReader();

    fileReader.readAsDataURL(files[0]);
    fileReader.onload = (event) => {
      let fileInput = !!event.target.result;
      if (fileInput) {
        try {
          Resizer.imageFileResizer(
            files[0],
            150,
            150,
            "JPEG",
            100,
            0,
            async (uri) => {
              const formData = { image: uri, type: "images" };
              const fileData = await dispatch(imageUpload({ formData }));
              console.log("Uploaded File Response:", fileData);

              if (fileData?.payload?.Status === "Y") {
                toast.success(fileData.payload.Msg);
                setID1Image(fileData.payload.name);
              } else {
                toast.error("File upload failed.");
              }
            },
            "base64",
            150,
            150
          );
        } catch (err) {
          console.log(err);
          toast.error("An error occurred during file processing.");
        }
      }
    };
  };
  const getFileID2Change = async (e) => {
    let files = e.target.files;
    let fileReader = new FileReader();

    fileReader.readAsDataURL(files[0]);
    fileReader.onload = (event) => {
      let fileInput = !!event.target.result;
      if (fileInput) {
        try {
          Resizer.imageFileResizer(
            files[0],
            150,
            150,
            "JPEG",
            100,
            0,
            async (uri) => {
              const formData = { image: uri, type: "images" };
              const fileData = await dispatch(imageUpload({ formData }));
              console.log("Uploaded File Response:", fileData);

              if (fileData?.payload?.Status === "Y") {
                toast.success(fileData.payload.Msg);
                setID2Image(fileData.payload.name);
              } else {
                toast.error("File upload failed.");
              }
            },
            "base64",
            150,
            150
          );
        } catch (err) {
          console.log(err);
          toast.error("An error occurred during file processing.");
        }
      }
    };
  };
  const getFilepanChange = async (e) => {
    let files = e.target.files;
    let fileReader = new FileReader();

    fileReader.readAsDataURL(files[0]);
    fileReader.onload = (event) => {
      let fileInput = !!event.target.result;
      if (fileInput) {
        try {
          Resizer.imageFileResizer(
            files[0],
            150,
            150,
            "JPEG",
            100,
            0,
            async (uri) => {
              const formData = { image: uri, type: "images" };
              const fileData = await dispatch(imageUpload({ formData }));
              console.log("Uploaded File Response:", fileData);

              if (fileData?.payload?.Status === "Y") {
                toast.success(fileData.payload.Msg);
                setPanImage(fileData.payload.name);
              } else {
                toast.error("File upload failed.");
              }
            },
            "base64",
            150,
            150
          );
        } catch (err) {
          console.log(err);
          toast.error("An error occurred during file processing.");
        }
      }
    };
  };
  console.log(panImage, "does");
  const getFilegstChange = async (e) => {
    let files = e.target.files;
    let fileReader = new FileReader();

    fileReader.readAsDataURL(files[0]);
    fileReader.onload = (event) => {
      let fileInput = !!event.target.result;
      if (fileInput) {
        try {
          Resizer.imageFileResizer(
            files[0],
            150,
            150,
            "JPEG",
            100,
            0,
            async (uri) => {
              const formData = { image: uri, type: "images" };
              const fileData = await dispatch(imageUpload({ formData }));
              console.log("Uploaded File Response:", fileData);

              if (fileData?.payload?.Status === "Y") {
                toast.success(fileData.payload.Msg);
                setGstImage(fileData.payload.name);
              } else {
                toast.error("File upload failed.");
              }
            },
            "base64",
            150,
            150
          );
        } catch (err) {
          console.log(err);
          toast.error("An error occurred during file processing.");
        }
      }
    };
  };

  // **********ScreenChange Function*********

  const screenChange = (event) => {
    setScreen(event.target.value);
    if (event.target.value == "0") {
      console.log(event.target.value, "--find event.target.value");

      if (recID && mode === "E") {
        dispatch(getFetchData({ accessID: "TR243", get: "get", recID }));
      } else {
        dispatch(getFetchData({ accessID: "TR243", get: "get", recID }));
      }
    }
    if (event.target.value == "3") {
      if (recID && mode === "E") {
        dispatch(VendorRegisterFetchData({ get: "get", recID }));
      } else {
        dispatch(VendorRegisterFetchData({ get: "", recID }));
      }
    }
    if (event.target.value == "4") {
      if (recID && mode === "E") {
        dispatch(VendorDefaultFetchData({ get: "get", recID }));
      } else {
        dispatch(VendorDefaultFetchData({ get: "", recID }));
      }
    }
    if (event.target.value == "5") {
      dispatch(
        fetchExplorelitview(
          "TR364",
          Subscriptionlastthree,
          "Party Documents",
          // `PartyID='${recID}' AND CompanyID='${CompanyID}'`,
          `CompanyID='${CompanyID}' AND (FIND_IN_SET('${recID}', DOC_HVRECID))`,
          ""
        )
      );

    }
    if (event.target.value == "1") {
      dispatch(PartyContactget({ VendorID: recID }));
    }

    if (event.target.value == "2") {
      dispatch(PartyBankget({ VendorID: recID }));
    }
  };


  const changeHandler = async (event) => {
    setUploading(true);   // Start loader

    setSelectedFile(event.target.files[0]);

    console.log(event.target.files[0]);

    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    formData.append("type", "images");

    const fileData = await dispatch(fnFileUpload(formData));
    var filePath = store.getState().globalurl.attachmentUrl + uploadFile

    console.log("fileData" + JSON.stringify(fileData));
    setUploadFile(fileData.payload.apiResponse);

    setUploading(false);  // Stop loader
  };

  const fnViewFile = (values) => {
    const baseUrl = store.getState().globalurl.attachmentUrl;

    const fileName = uploadFile || values.Attachment; // ✅ KEY FIX

    console.log("Final fileName:", fileName);

    if (!fileName) {
      toast.error("No file to view");
      return;
    }

    const encodedFileName = encodeURIComponent(fileName);
    const filePath = `${baseUrl}${encodedFileName}`;

    console.log("Opening:", filePath);

    window.open(filePath, "_blank");
  };
  function Employee() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>
            {show == "5"
              ? "List of Documents"
              : ""
            }
          </Typography>
          {show != "20" && (<Typography variant="h5">{`(${rowCount})`}</Typography>)}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
          {show != "5" && (
            <Tooltip title="ADD">
              <IconButton type="reset">
                <AddOutlinedIcon />
              </IconButton>
            </Tooltip>)}
        </Box>
      </GridToolbarContainer>
    );
  }
  // Page params

  const InitialValue = {
    code: data.Code || "",
    name: data.Name || "",
    Pancardnumber: data.PanCardNo || "",
    locality:
      data.LocalityID && data.LocalityID !== "0"
        ? {
          RecordID: data.LocalityID,
          Code: data.LocalityCode,
          Name: data.LocalityName,
        }
        : null,
    ReferenceBy:
      data.ReferenceID && data.ReferenceID !== "0"
        ? {
          RecordID: data.ReferenceID,
          Code: data.ReferenceByName,
          Name: data.ReferenceByName,
        }
        : null,
    address: data.Address || "",
    maplink: data.MapLocation || "",
    PanImg: data.PanImg || "",
    GstImg: data.gstImage || "",
    gstnumber: data.GstNo || "",
    mobilenumber: data.MobileNo || "",
    date: data.RegistrationDate || "",
    verifieddate: data.VerifyConfirmDate || "",
    emailid: data.EmailID || "",
    vendor: data.VendorCheckbox === "Y" ? true : false,
    customer: data.CustomerCheckbox === "Y" ? true : false,
    // prospect: data.Prospects === "Y" ? true : false,
    prospect:
      data?.RecordID
        ? data?.Prospects === "Y"   // EDIT mode
        : true,                     // ADD mode
    delete: data.DeleteFlag === "Y" ? true : false,
    BusinessPartner: data.BusinessPartner === "Y" ? true : false,
    Parent: data.ParentCheckBox === "Y" ? true : false,
    disable: data.Disable === "Y" ? true : false,
  };
  console.log(data.PanImg, "dooo");
  const Fnsave = async (values, del) => {
    setLoading(true);

    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
          ? "harddelete"
          : "update";
    // var isCheck = "N";
    // if (values.disable == true) {
    //   isCheck = "Y";
    // }

    // const isCheck = values.disable ? "Y" : "N";

    const idata = {
      RecordID: recID,
      Code: values.code,
      Name: values.name,
      LocalityID: values.locality?.RecordID || 0,
      LocalityName: values.locality?.Name || "",
      ReferenceID: values.ReferenceBy?.RecordID || 0,
      ReferenceName: values.ReferenceBy?.Name || "",
      PanCardNo: values.Pancardnumber,
      Address: values.address,
      MapLocation: values.maplink,
      PanImg: panImage,
      GstNo: values.gstnumber,
      GstImg: gstImage,
      MobileNo: values.mobilenumber,
      RegistrationDate: values.date,
      VerifyConfirmDate: values.verifieddate,
      EmailID: values.emailid,
      CompanyID,
      VendorCheckbox: values.vendor === true ? "Y" : "N",
      CustomerCheckbox: values.customer === true ? "Y" : "N",
      Prospects: values.prospect === true ? "Y" : "N",
      // LocalityID: "1",
      DeleteFlag: values.delete == true ? "Y" : "N",
      BusinessPartner: values.BusinessPartner == true ? "Y" : "N",
      ParentCheckBox: values.Parent == true ? "Y" : "N",
      Disable: values.disable == true ? "Y" : "N",
      Source: "Cloud",
      CreateBy: LoginID,
    };

    try {
      const response = await dispatch(postData({ accessID: "TR243V1", action, idata }));

      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);
        // navigate("/Apps/TR243/Party");
        navigate("/Apps/TR321/Party");
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      toast.error("An error occurred while saving data.");
    } finally {
      setLoading(false);
    }
  };

  //   const RegisterInitialValue = {
  //   Pancardnumber: data.PanCardNo || "",
  //   PanImg: data.PanImg || "",
  //   GstImg: data.gstImage || "",
  //   gstnumber: data.GstNo || "",
  // };
  const RegisterInitialValue = {
    code: partyRegistergetdata.Code || "",
    name: partyRegistergetdata.Name || "",
    Pancardnumber: partyRegistergetdata.PanCardNo || "",
    PanImg: partyRegistergetdata.PanImg || "",
    GstImg: partyRegistergetdata.GstImg || "",
    gstnumber: partyRegistergetdata.GstNo || "",
    date: partyRegistergetdata.RegistrationDate || "",
    verifieddate: partyRegistergetdata.VerifyConfirmDate || "",
    // aadharcardnumber: partyRegistergetdata.aadharcardnumber || ""
  };

  const RegisterFnsave = async (values, del) => {
    setLoading(true);
    // if (!panImage && !values.PanImg) {
    //   toast.error("Please upload PAN image before saving.");
    //   return;
    // }
    // if (!gstImage && !values.GstImg) {
    //   toast.error("Please upload GST image before saving.");
    //   return;
    // }
    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
          ? "harddelete"
          : "update";
    const idata = {
      RecordID: recID,
      PanCardNo: values.Pancardnumber,
      PanImg: panImage || values.PanImg,
      GstNo: values.gstnumber,
      GstImg: gstImage || values.GstImg,
      RegistrationDate: values.date,
      VerifyConfirmDate: values.verifieddate,
      // aadharcardnumber: values.aadharcardnumber
    };

    try {
      const response = await dispatch(
        VendorRegisterpostData({ accessID: "TR243", action, idata })
      );

      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);
        // navigate("/Apps/TR243/Party");
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      toast.error("An error occurred while saving data.");
    } finally {
      setLoading(false);
    }
  };

  const DefaultInitialValue = {
    code: partyDefaultgetdata.Code || "",
    name: partyDefaultgetdata.Name || "",
    Product:
      partyDefaultgetdata.DefaultProductID &&
        partyDefaultgetdata.DefaultProductID !== "0"
        ? {
          RecordID: partyDefaultgetdata.DefaultProductID,
          Name: partyDefaultgetdata.DefaultProductName,
        }
        : partyDefaultgetdata.DefaultProductID == null
          ? []
          : null,
    defaultDelivery: partyDefaultgetdata.DeliveryCharge || 0,
    DefaultPaymentMode: partyDefaultgetdata.DefaultPaymentMode || "",
    // DefaultPaymentMode:
    //   partyDefaultgetdata.DefaultPaymentMode === "COD"
    //     ? "COD"
    //     : partyDefaultgetdata.DefaultPaymentMode === "UPI"
    //     ? "UPI"
    //     : partyDefaultgetdata.DefaultPaymentMode === "Others"
    //     ? "Others"
    //     : null,
  };

  const DefaultFnsave = async (values, del) => {
    setLoading(true);

    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
          ? "harddelete"
          : "update";
    const idata = {
      RecordID: recID,
      DefaultProduct: values.Product.RecordID || 0,
      DeliveryCharge: values.defaultDelivery || 0,
      DefaultPaymentMode: values.DefaultPaymentMode || "",
    };

    try {
      const response = await dispatch(
        VendorDefaultPUTdata({ accessID: "TR243", action, idata })
      );

      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);
        // navigate("/Apps/TR243/Party");
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      toast.error("An error occurred while saving data.");
    } finally {
      setLoading(false);
    }
  };
  const BankInitialValue = {
    code: partyBankgetdata.Code || "",
    name: partyBankgetdata.Name || "",
    bankname: partyBankgetdata.BankName || "",
    Accounttype: partyBankgetdata.BankAccountType || "",
    branchname: partyBankgetdata.BankBranchName || "",
    ifsc: partyBankgetdata.BankIfsc || "",
    bankloc: partyBankgetdata.BankLocation || "",
    accountnumber: partyBankgetdata.BankAccountNo || "",
    bankaddress: partyBankgetdata.BankAddress || "",
    accountholdname: partyBankgetdata.BankAccountHolderName || "",
  };

  const Banksave = async (values, del) => {
    setLoading(true);

    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
          ? "harddelete"
          : "update";

    const idata = {
      VendorID: recID,
      BankName: values.bankname,
      BankBranchName: values.branchname,
      BankAccountHolderName: values.accountholdname,
      BankAccountNo: values.accountnumber,
      BankAccountType: values.Accounttype,
      BankIfsc: values.ifsc,
      BankLocation: values.bankloc,
      BankAddress: values.bankaddress,
    };

    try {
      const response = await dispatch(partyBankpostData({ action, idata }));

      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);
        // navigate("/Apps/TR243/Party");
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      toast.error("An error occurred while saving data.");
    } finally {
      setLoading(false);
    }
  };

  //Contact Details
  const contactInitialValue = {
    code: partyContactgetdata.Code || "",
    name: partyContactgetdata.Name || "",
    name1: partyContactgetdata.ContactPerson1 || "",
    name2: partyContactgetdata.ContactPerson2 || "",
    emailid1: partyContactgetdata.ContactPersonEmailID1 || "",
    emailid2: partyContactgetdata.ContactPersonEmailID2 || "",
    mobileno1: partyContactgetdata.ContactPersonMobileNo1 || "",
    mobileno2: partyContactgetdata.ContactPersonMobileNo2 || "",
    aadharcardnumber1: partyContactgetdata.AadhatNo1 || "",
    aadharcardnumber2: partyContactgetdata.AadhatNo2 || "",
    ContactPersonIDProofImg1:
      partyContactgetdata.ContactPersonIDProofImg1 || "",
    ContactPersonIDProofImg2:
      partyContactgetdata.ContactPersonIDProofImg2 || "",
  };
  const contactsave = async (values, del) => {
    setLoading(true);

    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
          ? "harddelete"
          : "update";

    const idata = {
      VendorID: recID,
      ContactPerson1: values.name1,
      ContactPerson2: values.name2,
      ContactPersonEmailID1: values.emailid1,
      ContactPersonEmailID2: values.emailid2,
      ContactPersonMobileNo1: values.mobileno1,
      ContactPersonMobileNo2: values.mobileno2,
      AadhatNo1: values.aadharcardnumber1,
      AadhatNo2: values.aadharcardnumber2,
      // ContactPersonIDProofImg1: data.ContactPersonIDProofImg1 || ID1Image,
      // ContactPersonIDProofImg2: data.ContactPersonIDProofImg2 || ID2Image,
      ContactPersonIDProofImg1: ID1Image || partyContactgetdata.ContactPersonIDProofImg1,
      ContactPersonIDProofImg2: ID2Image || partyContactgetdata.ContactPersonIDProofImg2,
    };

    try {
      const response = await dispatch(partyContactData({ action, idata }));

      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);
        // navigate("/Apps/TR243/Party");
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      toast.error("An error occurred while saving data.");
    } finally {
      setLoading(false);
    }
  };


  const selectCellRowData = ({ rowData, mode, field, setFieldValue }) => {
    setFunMode(mode);
    setLaoMode(mode);

    if (mode == "A") {
      SetEmpLoaData({
        description: "",
        Attachment: "",
        recordID: "",
        category: "",
        RenewalDate: "",
        personal: false,
        renewal: false,
      });
    } else {

      if (field == "action") {
        SetEmpLoaData({
          description: rowData.Description,
          recordID: rowData.RecordID,
          category: rowData.Category,
          RenewalDate: rowData.NextRenewalRequiredDate,
          personal: rowData.Personal,
          renewal: rowData.RenewalRequired,
          Attachment: rowData.Attachment,
        });
      }
    }
    console.log(selectCellRowData, "Itemservices");
  };


  const AttachmentInitialValues = {
    code: data.Code,
    description: data.Name,
    LoaDescription: empLoaData.description,
    personal: empLoaData.personal === "Y" ? true : false,
    renewal: empLoaData.renewal === "Y" ? true : false,
    // category: Data.Category,
    Attachment: empLoaData.Attachment || "",
    category:
      empLoaData.category == "Education"
        ? "EC"
        : empLoaData.category == "Insurance "
          ? "IS"
          : empLoaData.category == "Award "
            ? "AD"
            : empLoaData.category == "Certificate "
              ? "CT"
              : empLoaData.category == "Warranty "
                ? "WT"
                : empLoaData.category == "Others "
                  ? "OS"
                  : "",
    RenewalDate: empLoaData.RenewalDate || "",
    Sortorder: "",
  };
  const FnAttachment = async (values, resetForm, del) => {
    let action =
      laomode === "A" && !del
        ? "insert"
        : laomode === "E" && del
          ? "harddelete"
          : "update";

    console.log(values);

    const idata = {
      RecordID: empLoaData.recordID,
      EmployeeID: recID,
      Description: values.LoaDescription,
      //  ImageName: ImageName ? ImageName:Data.ImageName,
      Attachment: uploadFile || values.Attachment || "",
      Personal: values.personal === true ? "Y" : "N",
      RenewalRequired: values.renewal === true ? "Y" : "N",
      Category: values.category,
      NextRenewalRequiredDate: values.RenewalDate,
      Sortorder: 0,
      CompanyID,
    };
    const response = await dispatch(
      explorePostData({ accessID: "TR210", action, idata })
    );
    if (response.payload.Status == "Y") {
      toast.success(response.payload.Msg);
      dispatch(
        fetchExplorelitview(
          "TR210",
          "List of Documents",
          `EmployeeID=${recID}`,
          ""
        )
      );
      resetForm();
      selectCellRowData({ rowData: {}, mode: "A", field: "" });
      resetForm();
    } else {
      toast.error(response.payload.Msg);
    }
  };


  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          // navigate("/Apps/TR243/Party");
          navigate("/Apps/TR321/Party");
        }
      }
    });
  };



  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : null}

      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
        <Box
          display="flex"
          justifyContent="space-between"
          p={mode == "A" ? 2 : 1}
        >
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Box
              display={isNonMobile ? "flex" : "none"}
              borderRadius="3px"
              alignItems="center"
            >
              <Breadcrumbs
                maxItems={3}
                aria-label="breadcrumb"
                separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
              >
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                  onClick={() => {
                    setScreen(0);
                  }}
                >
                  {/* Party ({state.PName}) */}
                  {mode === "E" ? `Party(${state.PName})` : "Party(New)"}
                </Typography>
                {show == "1" ? (
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                  >
                    Contact Details
                  </Typography>
                ) : (
                  false
                )}
                {show == "2" ? (
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                  >
                    Bank Details
                  </Typography>
                ) : (
                  false
                )}
                {show == "3" ? (
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                  >
                    Registration
                  </Typography>
                ) : (
                  false
                )}
                {show == "4" ? (
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                  >
                    Default Settings
                  </Typography>
                ) : (
                  false
                )}
                {show == "5" ? (
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                  >
                    List Of Documents
                  </Typography>
                ) : (
                  false
                )}
              </Breadcrumbs>
            </Box>
          </Box>

          <Box display="flex">
            {mode !== "A" ? (
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">Explore</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={show}
                  label="Explore"
                  onChange={screenChange}
                >
                  <MenuItem value={0}>Party</MenuItem>
                  <MenuItem value={3}>Registration</MenuItem>
                  <MenuItem value={4}>Default Settings</MenuItem>
                  <MenuItem value={2}>Bank Details</MenuItem>
                  <MenuItem value={1}>Contact Details</MenuItem>
                  <MenuItem value={5}>List Of Documents</MenuItem>
                  {/* <MenuItem value={6}>Unit</MenuItem>  */}
                  {/* {initialValues.employeetype === "CI" ? (
                                              <MenuItem value={8}>Contracts In</MenuItem>
                                            ) : null}
                                            {initialValues.employeetype === "CO" ? (
                                              <MenuItem value={11}>Contracts Out</MenuItem>
                                            ) : null}
                                            <MenuItem value={1}>Employee Process</MenuItem> */}
                  {/* <MenuItem value={3}>Managers</MenuItem>
                                            <MenuItem value={4}>Deployment</MenuItem>
                                            <MenuItem value={9}>Geo Location</MenuItem>
                                            <MenuItem value={10}>Leave Configuration</MenuItem>
                                            <MenuItem value={6}>List of Attachments</MenuItem>
                                            <MenuItem value={7}>Item Custody</MenuItem> */}
                </Select>
              </FormControl>
            ) : (
              false
            )}
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      {/* {!getLoading ? ( */}
      {show == "0" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={InitialValue}
            validationSchema={validationSchema}
            enableReinitialize={true}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                Fnsave(values);
              }, 100);
            }}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  {CompanyAutoCode == "Y" ? (
                    <TextField
                      name="code"
                      type="text"
                      id="code"
                      label="Code"
                      variant="standard"
                      placeholder="Auto"
                      focused
                      // required
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.code && !!errors.code}
                      helperText={touched.code && errors.code}
                      sx={{
                        backgroundColor: "#ffffff", // Set the background to white
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                        },
                      }}
                      InputProps={{ readOnly: true }}
                    // autoFocus
                    />
                  ) : (
                    <TextField
                      name="code"
                      type="text"
                      id="code"
                      label={
                        <>
                          Code
                          <span style={{ color: "red", fontSize: "20px" }}>
                            *
                          </span>
                        </>
                      }
                      variant="standard"
                      focused
                      // required
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.code && !!errors.code}
                      helperText={touched.code && errors.code}
                      sx={{
                        backgroundColor: "#ffffff", // Set the background to white
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                        },
                      }}
                      autoFocus
                    />
                  )}
                  <TextField
                    name="name"
                    type="text"
                    id="name"
                    label={
                      <>
                        Name
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    // required
                    autoFocus={CompanyAutoCode == "Y"}
                  />

                  <TextField
                    name="mobilenumber"
                    id="mobilenumber"
                    label={
                      <>
                        Contact Mobile or Landline Number
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.mobilenumber}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Only allow numbers and max 10 digits
                      if (/^\d{0,11}$/.test(value)) {
                        handleChange(e);
                      }
                    }}
                    error={!!touched.mobilenumber && !!errors.mobilenumber}
                    helperText={touched.mobilenumber && errors.mobilenumber}
                    inputProps={{ maxLength: 10 }}
                    sx={{ backgroundColor: "#ffffff" }}
                    InputProps={{
                      inputProps: {
                        style: { textAlign: 'left' }
                      }
                    }}
                  />
                  <TextField
                    name="emailid"
                    type="text"
                    id="emailid"
                    label="Email ID"
                    variant="standard"
                    focused
                    value={values.emailid}
                    error={!!touched.emailid && !!errors.emailid}
                    helperText={touched.emailid && errors.emailid}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                  // autoFocus
                  />

                  <TextField
                    name="address"
                    type="text"
                    id="address"
                    label="Address"
                    variant="standard"
                    focused
                    multiline
                    rows={2}
                    value={values.address}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    // error={!!touched.address && !!errors.address}
                    // helperText={touched.address && errors.address}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                  />

                  <CheckinAutocomplete
                    id="locality"
                    name="locality"
                    label="Locality"
                    // label={
                    //   <>
                    //     Locality
                    //     <span style={{ color: "red", fontSize: "20px" }}>
                    //       *
                    //     </span>
                    //   </>
                    // }
                    variant="outlined"
                    value={values.locality}
                    onChange={(newValue) => {
                      setFieldValue("locality", newValue);
                      console.log(newValue, "--newvalue locality");
                      console.log(newValue.RecordID, "locality RecordID");
                    }}
                    error={!!touched.locality && !!errors.locality}
                    helperText={touched.locality && errors.locality}
                    url={`${listViewurl}?data={"Query":{"AccessID":"2128","ScreenName":"Locality","Filter":"CompanyID=${CompanyID}","Any":"","VerticalLicense":"${Subscriptionlastthree}"}}`}
                  />
                  {/* <TextField
                    name="Pancardnumber"
                    label="Pan Card Number"
                    variant="standard"
                    focused
                    value={values.Pancardnumber}
                    onBlur={handleBlur}
                    // required
                    onChange={(e) => {
                      const input = e.target.value.toUpperCase();
                      if (/^[A-Z0-9]*$/.test(input) || input === "") {
                        handleChange({
                          target: {
                            name: "Pancardnumber",
                            value: input,
                          },
                        });
                      }
                    }}
                    error={!!touched.Pancardnumber && !!errors.Pancardnumber}
                    helperText={touched.Pancardnumber && errors.Pancardnumber}
                    sx={{
                      backgroundColor: "#ffffff",
                    }}
                    
                  />
                  <TextField
                    name="gstnumber"
                    label="GST Number"
                    variant="standard"
                    focused
                    value={values.gstnumber}
                    // required
                    onBlur={handleBlur}
                    onChange={(e) => {
                      const input = e.target.value.toUpperCase();
                      if (/^[0-9A-Z]*$/.test(input) || input === "") {
                        // This updates Formik value correctly
                        handleChange({
                          target: {
                            name: "gstnumber",
                            value: input,
                          },
                        });
                      }
                    }}
                    error={!!touched.gstnumber && !!errors.gstnumber}
                    helperText={touched.gstnumber && errors.gstnumber}
                    sx={{
                      backgroundColor: "#ffffff",
                    }}
                    // autoFocus
                  /> */}

                  {/* <TextField
                    name="date"
                    type="date"
                    id="date"
                    label="Date of Registration"
                    variant="standard"
                    focused
                    inputFormat="YYYY-MM-DD"
                    value={values.date}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.date && !!errors.date}
                    helperText={touched.date && errors.date}
                    // required
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    //inputProps={{ max: new Date().toISOString().split("T")[0] }}
                  />
                  <TextField
                    name="verifieddate"
                    type="date"
                    id="verifieddate"
                    label="Date of Verification & Confirmation"
                    variant="standard"
                    focused
                    inputFormat="YYYY-MM-DD"
                    value={values.verifieddate}
                    // required
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.date && !!errors.date}
                    helperText={touched.date && errors.date}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ",
                      },
                    }}
                  /> */}

                  <TextField
                    name="maplink"
                    type="text"
                    id="maplink"
                    label="Map Location"
                    variant="standard"
                    focused
                    value={values.maplink}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    // error={!!touched.maplink && !!errors.maplink}
                    // helperText={touched.maplink && errors.maplink}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                  />
                  <CheckinAutocomplete
                    id="ReferenceBy"
                    name="ReferenceBy"
                    label="Partner Reference"
                    variant="outlined"
                    value={values.ReferenceBy}
                    onChange={(newValue) => {
                      setFieldValue("ReferenceBy", newValue);
                      // console.log(newValue, "--newvalue ReferenceBy");
                      // console.log(newValue.RecordID, "ReferenceBy RecordID");
                    }}
                    // error={!!touched.ReferenceBy && !!errors.ReferenceBy}
                    // helperText={touched.ReferenceBy && errors.ReferenceBy}
                    url={`${listViewurl}?data={"Query":{"AccessID":"2131","ScreenName":"Partner Reference","Filter":"ParentID=${CompanyID}","Any":"","VerticalLicense":"${Subscriptionlastthree}"}}`}
                  />

                  {/* panimage */}

                  <Box display="flex" flexDirection="column" gap={1}>
                    {/* First row */}
                    <Box display="flex" gap={2}>
                      <Box display="flex" alignItems="center">
                        <Field
                          type="checkbox"
                          name="vendor"
                          id="vendor"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          as={Checkbox}
                        />
                        <FormLabel focused={false}>Vendor/Supplier</FormLabel>
                      </Box>
                      <Box display="flex" alignItems="center">
                        <Field
                          //    size="small"
                          type="checkbox"
                          name="customer"
                          id="customer"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          as={Checkbox}
                          label="Customer"
                        />
                        <FormLabel focused={false}>Customer</FormLabel>
                      </Box>
                      <Box display="flex" alignItems="center">
                        <Field
                          //    size="small"
                          type="checkbox"
                          name="prospect"
                          id="prospect"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          as={Checkbox}
                          label="Prospects"
                        />

                        <FormLabel focused={false}>Prospects</FormLabel>
                      </Box>
                      <Box display="flex" alignItems="center">
                        <Field
                          //    size="small"
                          type="checkbox"
                          name="BusinessPartner"
                          id="BusinessPartner"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          as={Checkbox}
                          label="Business Partner"
                        />
                        <FormLabel focused={false}>Partner</FormLabel>
                      </Box>
                      <Box display="flex" alignItems="center">
                        <Field
                          type="checkbox"
                          name="Parent"
                          id="Parent"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          as={Checkbox}
                          label="Parent"
                        />
                        <FormLabel focused={false}>Parent</FormLabel>
                      </Box>
                      <Box display="flex" alignItems="center">
                        <Field
                          //  size="small"
                          type="checkbox"
                          name="delete"
                          id="delete"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          as={Checkbox}
                          label="Delete"
                        />

                        <FormLabel focused={false}>Delete</FormLabel>
                      </Box>
                      <Box display="flex" alignItems="center">
                        <Field
                          //  size="small"
                          type="checkbox"
                          name="disable"
                          id="disable"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          as={Checkbox}
                          label="Disable"
                        />

                        <FormLabel focused={false}>Disable</FormLabel>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box display="flex" justifyContent="end" padding={1} gap="20px">
                  {/* <Tooltip title="PAN Upload">
                    <IconButton
                      size="small"
                      color="warning"
                      aria-label="upload picture"
                      component="label"
                    >
                      <input
                        hidden
                        accept="all/*"
                        type="file"
                        onChange={getFilepanChange}
                      />
                      <PictureAsPdfOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                  <Button
                    size="small"
                    variant="contained"
                    component={"a"}
                    onClick={() => {
                      data.PanImg || panImage
                        ? window.open(
                            panImage
                              ? store.getState().globalurl.attachmentUrl +
                                  panImage
                              : store.getState().globalurl.attachmentUrl +
                                  data.PanImg,
                            "_blank"
                          )
                        : toast.error("Please Upload File");
                    }}
                  >
                    PAN Image View
                  </Button>
                  <Tooltip title="GST Upload">
                    <IconButton
                      size="small"
                      color="warning"
                      aria-label="upload picture"
                      component="label"
                    >
                      <input
                        hidden
                        accept="all/*"
                        type="file"
                        onChange={getFilegstChange}
                      />
                      <PictureAsPdfOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                  <Button
                    size="small"
                    variant="contained"
                    component={"a"}
                    onClick={() => {
                      data.GstImg || gstImage
                        ? window.open(
                            gstImage
                              ? store.getState().globalurl.attachmentUrl +
                                  gstImage
                              : store.getState().globalurl.attachmentUrl +
                                  data.GstImg,
                            "_blank"
                          )
                        : toast.error("Please Upload File");
                    }}
                  >
                    GST Image View
                  </Button> */}
                  {YearFlag == "true" ? (
                    <LoadingButton
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={isLoading}
                    >
                      Save
                    </LoadingButton>
                  ) : (
                    <Button
                      color="secondary"
                      variant="contained"
                      disabled={true}
                    >
                      Save
                    </Button>
                  )}

                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      // navigate("/Apps/TR243/Party");
                      navigate("/Apps/TR321/Party");
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
      {show == "1" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={contactInitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                contactsave(values);
              }, 100);
            }}
            validationSchema={validationSchema3}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  {CompanyAutoCode == "Y" ? (
                    <TextField
                      name="code"
                      type="text"
                      id="code"
                      label="Code"
                      variant="standard"
                      placeholder="Auto"
                      focused
                      // required
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.code && !!errors.code}
                      helperText={touched.code && errors.code}
                      sx={{
                        backgroundColor: "#ffffff", // Set the background to white
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                        },
                      }}
                      InputProps={{ readOnly: true }}
                    // autoFocus
                    />
                  ) : (
                    <TextField
                      name="code"
                      type="text"
                      id="code"
                      label={
                        <>
                          Code
                          <span style={{ color: "red", fontSize: "20px" }}>
                            *
                          </span>
                        </>
                      }
                      variant="standard"
                      focused
                      // required
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.code && !!errors.code}
                      helperText={touched.code && errors.code}
                      sx={{
                        backgroundColor: "#ffffff", // Set the background to white
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                        },
                      }}
                      autoFocus
                    />
                  )}
                  <TextField
                    name="name"
                    type="text"
                    id="name"
                    label={
                      <>
                        Name
                        {/* <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span> */}
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    InputProps={{
                      inputProps: {
                        readOnly: true,
                      },
                    }}
                    // required
                    autoFocus={CompanyAutoCode == "Y"}
                  />
                  <Box
                    sx={{
                      padding: 1.5,
                      backgroundColor: "#b2dfdb", // light green
                      borderRadius: 1,
                      width: "100%",
                    }}
                  >
                    <Typography variant="h5" fontWeight="bold">
                      Contact Person 1
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      padding: 1.5,
                      backgroundColor: "#b2dfdb",
                      borderRadius: 1,
                      width: "100%",
                    }}
                  >
                    <Typography variant="h5" fontWeight="bold">
                      Contact Person 2
                    </Typography>
                  </Box>
                  {/* </Box> */}

                  {/* <Typography>Contact Person 2</Typography> */}
                  <TextField
                    name="name1"
                    label={
                      <>
                        Name
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.name1}
                    // required
                    onBlur={handleBlur}
                    onChange={handleChange}
                    // onChange={(e) => {
                    //   const input = e.target.value.toUpperCase();
                    //   if (/^[A-Z0-9]*$/.test(input) || input === "") {
                    //     handleChange({
                    //       target: {
                    //         name: "name1",
                    //         value: input,
                    //       },
                    //     });
                    //   }
                    // }}
                    error={!!touched.name1 && !!errors.name1}
                    helperText={touched.name1 && errors.name1}
                    sx={{
                      backgroundColor: "#ffffff",
                    }}
                    autoFocus
                  />
                  <TextField
                    name="name2"
                    label="Name"
                    variant="standard"
                    focused
                    value={values.name2}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    // onChange={(e) => {
                    //   const input = e.target.value.toUpperCase();
                    //   if (/^[0-9A-Z]*$/.test(input) || input === "") {
                    //     // This updates Formik value correctly
                    //     handleChange({
                    //       target: {
                    //         name: "name2",
                    //         value: input,
                    //       },
                    //     });
                    //   }
                    // }}
                    error={!!touched.name2 && !!errors.name2}
                    helperText={touched.name2 && errors.name2}
                    sx={{
                      backgroundColor: "#ffffff",
                    }}
                    autoFocus
                  />
                  <TextField
                    name="emailid1"
                    type="tel"
                    id="emailid1"
                    label={
                      <>
                        Email ID
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    // required
                    focused
                    value={values.emailid1}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    // onChange={(e) => {
                    //   const value = e.target.value;
                    //   // Only allow numbers and max 10 digits
                    //   if (/^\d{0,10}$/.test(value)) {
                    //     handleChange(e);
                    //   }
                    // }}
                    error={!!touched.emailid1 && !!errors.emailid1}
                    helperText={touched.emailid1 && errors.emailid1}
                    // inputProps={{ maxLength: 10 }}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    autoFocus
                  />

                  <TextField
                    name="emailid2"
                    type="text"
                    id="emailid2"
                    label="Email ID"
                    variant="standard"
                    focused
                    value={values.emailid2}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    autoFocus
                  />
                  <TextField
                    name="mobileno1"
                    type="tel"
                    id="mobileno1"
                    label={
                      <>
                        Mobile No
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.mobileno1}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.mobileno1 && !!errors.mobileno1}
                    helperText={touched.mobileno1 && errors.mobileno1}
                    // required
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    autoFocus
                  />
                  <TextField
                    name="mobileno2"
                    type="tel"
                    id="mobileno2"
                    label="Mobile No"
                    variant="standard"
                    focused
                    inputProps={{ maxLength: 10 }}
                    value={values.mobileno2}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    autoFocus
                  />
                  <TextField
                    fullWidth
                    variant="standard"
                    type="number"
                    id="aadharcardnumber1"
                    name="aadharcardnumber1"
                    value={values.aadharcardnumber1}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    label="Aadhar Card No"
                    focused
                    // onWheel={(e) => e.target.blur()}
                    error={
                      touched.aadharcardnumber1 &&
                      Boolean(errors.aadharcardnumber1)
                    }
                    helperText={
                      touched.aadharcardnumber1 && errors.aadharcardnumber1
                    }
                  />
                  <TextField
                    fullWidth
                    variant="standard"
                    type="number"
                    id="aadharcardnumber2"
                    name="aadharcardnumber2"
                    value={values.aadharcardnumber2}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    label="Aadhar Card No"
                    focused
                    // onWheel={(e) => e.target.blur()}
                    error={
                      touched.aadharcardnumber2 &&
                      Boolean(errors.aadharcardnumber2)
                    }
                    helperText={
                      touched.aadharcardnumber2 && errors.aadharcardnumber2
                    }
                  />
                </Box>
                <Grid container spacing={2}>
                  {/* ID Proof (Left side – 50%) */}
                  <Grid item xs={12} md={6}>
                    <Box display="flex" alignItems="center" gap={2}>
                      <Tooltip title="ID Proof">
                        <IconButton
                          size="small"
                          color="warning"
                          aria-label="upload picture"
                          component="label"
                        >
                          <input
                            hidden
                            accept="all/*"
                            type="file"
                            // onChange={getFilepanChange}
                            onChange={getFileID1Change}
                          />
                          <PictureAsPdfOutlinedIcon />
                        </IconButton>
                      </Tooltip>

                      <Button
                        size="small"
                        variant="contained"
                        // onClick={() => {
                        //   data.ContactPersonIDProofImg1 || ID1Image
                        //     ? window.open(
                        //         ID1Image
                        //           ? store.getState().globalurl.attachmentUrl +
                        //               ID1Image
                        //           : store.getState().globalurl.attachmentUrl +
                        //               data.ContactPersonIDProofImg1,
                        //         "_blank"
                        //       )
                        //     : toast.error("Please Upload File");
                        // }}
                        onClick={() => {
                          partyContactgetdata.ContactPersonIDProofImg1 || ID1Image
                            ? window.open(
                              ID1Image
                                ? store.getState().globalurl.attachmentUrl +
                                ID1Image
                                : store.getState().globalurl.attachmentUrl +
                                partyContactgetdata.ContactPersonIDProofImg1,
                              "_blank"
                            )
                            : toast.error("Please Upload File");
                        }}
                      >
                        ID Proof View
                      </Button>
                    </Box>
                  </Grid>

                  {/* GST Proof (Right side – 50%) */}
                  <Grid item xs={12} md={6}>
                    <Box display="flex" alignItems="center" gap={2}>
                      <Tooltip title="ID Proof">
                        <IconButton
                          size="small"
                          color="warning"
                          aria-label="upload picture"
                          component="label"
                        >
                          <input
                            hidden
                            accept="all/*"
                            type="file"
                            // onChange={getFilegstChange}
                            onChange={getFileID2Change}
                          />
                          <PictureAsPdfOutlinedIcon />
                        </IconButton>
                      </Tooltip>

                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => {
                          partyContactgetdata.ContactPersonIDProofImg2 || ID2Image
                            ? window.open(
                              ID2Image
                                ? store.getState().globalurl.attachmentUrl +
                                ID2Image
                                : store.getState().globalurl.attachmentUrl +
                                partyContactgetdata.ContactPersonIDProofImg2,
                              "_blank"
                            )
                            : toast.error("Please Upload File");
                        }}
                      >
                        ID Proof View
                      </Button>
                    </Box>
                  </Grid>
                </Grid>

                <Box
                  display="flex"
                  justifyContent="flex-end"
                  padding={1}
                  gap="20px"
                >
                  {/* GSTimage */}

                  {YearFlag == "true" ? (
                    <LoadingButton
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={isLoading}
                    >
                      Save
                    </LoadingButton>
                  ) : (
                    <Button
                      color="secondary"
                      variant="contained"
                      disabled={true}
                    >
                      Save
                    </Button>
                  )}
                  {/* {YearFlag == "true" ? (
                    <Button
                      color="error"
                      variant="contained"
                      onClick={() => {
                        Fnsave(values, "harddelete");
                      }}
                    >
                      Delete
                    </Button>
                  ) : (
                    <Button color="error" variant="contained" disabled={true}>
                      Delete
                    </Button>
                  )} */}

                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      setScreen(0);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
      {show == "2" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={BankInitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                Banksave(values);
              }, 100);
            }}
            validationSchema={validationSchema2}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  {CompanyAutoCode == "Y" ? (
                    <TextField
                      name="code"
                      type="text"
                      id="code"
                      label="Code"
                      variant="standard"
                      placeholder="Auto"
                      focused
                      // required
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.code && !!errors.code}
                      helperText={touched.code && errors.code}
                      sx={{
                        backgroundColor: "#ffffff", // Set the background to white
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                        },
                      }}
                      InputProps={{ readOnly: true }}
                    // autoFocus
                    />
                  ) : (
                    <TextField
                      name="code"
                      type="text"
                      id="code"
                      label={
                        <>
                          Code
                          <span style={{ color: "red", fontSize: "20px" }}>
                            *
                          </span>
                        </>
                      }
                      variant="standard"
                      focused
                      // required
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.code && !!errors.code}
                      helperText={touched.code && errors.code}
                      sx={{
                        backgroundColor: "#ffffff", // Set the background to white
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                        },
                      }}
                      autoFocus
                    />
                  )}
                  <TextField
                    name="name"
                    type="text"
                    id="name"
                    label={
                      <>
                        Name
                        {/* <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span> */}
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    InputProps={{
                      inputProps: {
                        readOnly: true,
                      },
                    }}
                    // required
                    autoFocus={CompanyAutoCode == "Y"}
                  />
                  <TextField
                    name="bankname"
                    type="text"
                    id="bankname"
                    label={
                      <>
                        Bank Name
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.bankname}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.bankname && !!errors.bankname}
                    helperText={touched.bankname && errors.bankname}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    autoFocus
                  />
                  <TextField
                    name="Accounttype"
                    type="text"
                    id="Accounttype"
                    label={
                      <>
                        Account Type
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.Accounttype}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.Accounttype && !!errors.Accounttype}
                    helperText={touched.Accounttype && errors.Accounttype}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    autoFocus
                  />
                  <TextField
                    name="branchname"
                    label={
                      <>
                        Branch Name
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.branchname}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    // onChange={(e) => {
                    //   const input = e.target.value.toUpperCase();
                    //   if (/^[A-Z0-9]*$/.test(input) || input === "") {
                    //     handleChange({
                    //       target: {
                    //         name: "branchname",
                    //         value: input,
                    //       },
                    //     });
                    //   }
                    // }}
                    error={!!touched.branchname && !!errors.branchname}
                    helperText={touched.branchname && errors.branchname}
                    sx={{
                      backgroundColor: "#ffffff",
                    }}
                    autoFocus
                  />
                  <TextField
                    name="ifsc"
                    label={
                      <>
                        IFSC Code
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.ifsc}
                    onBlur={handleBlur}
                    //  onChange={handleChange}
                    onChange={(e) => {
                      const input = e.target.value.toUpperCase();
                      if (/^[0-9A-Z]*$/.test(input) || input === "") {
                        // This updates Formik value correctly
                        handleChange({
                          target: {
                            name: "ifsc",
                            value: input,
                          },
                        });
                      }
                    }}
                    error={!!touched.ifsc && !!errors.ifsc}
                    helperText={touched.ifsc && errors.ifsc}
                    sx={{
                      backgroundColor: "#ffffff",
                    }}
                    autoFocus
                  />
                  <TextField
                    name="accountholdname"
                    type="text"
                    id="accountholdname"
                    label={
                      <>
                        Account Holder Name
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.accountholdname}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={
                      !!touched.accountholdname && !!errors.accountholdname
                    }
                    helperText={
                      touched.accountholdname && errors.accountholdname
                    }
                    // inputProps={{ maxLength: 10 }}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    autoFocus
                  />

                  <TextField
                    name="bankloc"
                    type="text"
                    id="bankloc"
                    label={
                      <>
                        Bank Location
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.bankloc}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    autoFocus
                    error={!!touched.bankloc && !!errors.bankloc}
                    helperText={touched.bankloc && errors.bankloc}
                  />
                  {/* <TextField
                    name="accountnumber"
                    type="number"
                    id="accountnumber"
                    label="Account Number"
                    variant="standard"
                    focused
                     required
                    value={values.accountnumber}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    autoFocus
                  /> */}
                  <TextField
                    name="accountnumber"
                    type="text" // use "text" instead of "number" to preserve leading 0s and better control
                    id="accountnumber"
                    label={
                      <>
                        Account Number
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.accountnumber}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      const input = e.target.value;
                      // Allow only digits
                      if (/^\d*$/.test(input)) {
                        handleChange({
                          target: {
                            name: "accountnumber",
                            value: input,
                          },
                        });
                      }
                    }}
                    error={!!touched.accountnumber && !!errors.accountnumber}
                    helperText={touched.accountnumber && errors.accountnumber}
                    sx={{
                      backgroundColor: "#ffffff",
                    }}
                    autoFocus
                  />
                  <TextField
                    name="bankaddress"
                    type="text"
                    id="bankaddress"
                    label={
                      <>
                        Bank Address
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.bankaddress}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    error={!!touched.bankaddress && !!errors.bankaddress}
                    helperText={touched.bankaddress && errors.bankaddress}
                    autoFocus
                  />
                </Box>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  padding={1}
                  gap="20px"
                >
                  {YearFlag == "true" ? (
                    <LoadingButton
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={isLoading}
                    >
                      Save
                    </LoadingButton>
                  ) : (
                    <Button
                      color="secondary"
                      variant="contained"
                      disabled={true}
                    >
                      Save
                    </Button>
                  )}{" "}
                  {/* {YearFlag == "true" ? (
                    <Button
                      color="error"
                      variant="contained"
                      onClick={() => {
                        Banksave(values, "harddelete");
                      }}
                    >
                      Delete
                    </Button>
                  ) : (
                    <Button color="error" variant="contained" disabled={true}>
                      Delete
                    </Button>
                  )} */}
                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      setScreen(0);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}

      {show == "3" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={RegisterInitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                RegisterFnsave(values);
              }, 100);
            }}
            validationSchema={validationSchema4}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                {!isPartyRegisterLoading ? (
                  <>
                    <Box
                      display="grid"
                      gap={formGap}
                      padding={1}
                      gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                      // gap="30px"
                      sx={{
                        "& > div": {
                          gridColumn: isNonMobile ? undefined : "span 2",
                        },
                      }}
                    >
                      {CompanyAutoCode == "Y" ? (
                        <TextField
                          name="code"
                          type="text"
                          id="code"
                          label="Code"
                          variant="standard"
                          placeholder="Auto"
                          focused
                          // required
                          value={values.code}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.code && !!errors.code}
                          helperText={touched.code && errors.code}
                          sx={{
                            backgroundColor: "#ffffff", // Set the background to white
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                            },
                          }}
                          InputProps={{ readOnly: true }}
                        // autoFocus
                        />
                      ) : (
                        <TextField
                          name="code"
                          type="text"
                          id="code"
                          label={
                            <>
                              Code
                              <span style={{ color: "red", fontSize: "20px" }}>
                                *
                              </span>
                            </>
                          }
                          variant="standard"
                          focused
                          // required
                          value={values.code}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.code && !!errors.code}
                          helperText={touched.code && errors.code}
                          sx={{
                            backgroundColor: "#ffffff", // Set the background to white
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                            },
                          }}
                          autoFocus
                        />
                      )}
                      <TextField
                        name="name"
                        type="text"
                        id="name"
                        label={
                          <>
                            Name
                            {/* <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span> */}
                          </>
                        }
                        variant="standard"
                        focused
                        value={values.name}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.name && !!errors.name}
                        helperText={touched.name && errors.name}
                        sx={{
                          backgroundColor: "#ffffff", // Set the background to white
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                          },
                        }}
                        InputProps={{
                          inputProps: {
                            readOnly: true,
                          },
                        }}
                        // required
                        autoFocus={CompanyAutoCode == "Y"}
                      />
                      <TextField
                        name="Pancardnumber"
                        label="Pan Card Number"
                        variant="standard"
                        focused
                        value={values.Pancardnumber}
                        onBlur={handleBlur}
                        // required
                        onChange={(e) => {
                          const input = e.target.value.toUpperCase();
                          if (/^[A-Z0-9]*$/.test(input) || input === "") {
                            handleChange({
                              target: {
                                name: "Pancardnumber",
                                value: input,
                              },
                            });
                          }
                        }}
                        error={
                          !!touched.Pancardnumber && !!errors.Pancardnumber
                        }
                        helperText={
                          touched.Pancardnumber && errors.Pancardnumber
                        }
                        sx={{
                          backgroundColor: "#ffffff",
                        }}
                        autoFocus
                      />
                      <TextField
                        name="gstnumber"
                        label="GST Number"
                        variant="standard"
                        focused
                        value={values.gstnumber}
                        // required
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const input = e.target.value.toUpperCase();
                          if (/^[0-9A-Z]*$/.test(input) || input === "") {
                            // This updates Formik value correctly
                            handleChange({
                              target: {
                                name: "gstnumber",
                                value: input,
                              },
                            });
                          }
                        }}
                        error={!!touched.gstnumber && !!errors.gstnumber}
                        helperText={touched.gstnumber && errors.gstnumber}
                        sx={{
                          backgroundColor: "#ffffff",
                        }}
                      // autoFocus
                      />

                      <TextField
                        name="date"
                        type="date"
                        id="date"
                        label="Date of Registration"
                        variant="standard"
                        focused
                        inputFormat="YYYY-MM-DD"
                        value={values.date}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.date && !!errors.date}
                        helperText={touched.date && errors.date}
                        // required
                        sx={{
                          backgroundColor: "#ffffff", // Set the background to white
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                          },
                        }}
                      //inputProps={{ max: new Date().toISOString().split("T")[0] }}
                      />
                      <TextField
                        name="verifieddate"
                        type="date"
                        id="verifieddate"
                        label="Date of Verification & Confirmation"
                        variant="standard"
                        focused
                        inputFormat="YYYY-MM-DD"
                        value={values.verifieddate}
                        // required
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.date && !!errors.date}
                        helperText={touched.date && errors.date}
                        sx={{
                          backgroundColor: "#ffffff",
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#f5f5f5 ",
                          },
                        }}
                      />
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="end"
                      padding={1}
                      gap="20px"
                    >
                      <Tooltip title="PAN Upload">
                        <IconButton
                          size="small"
                          color="warning"
                          aria-label="upload picture"
                          component="label"
                        >
                          <input
                            hidden
                            accept="all/*"
                            type="file"
                            onChange={getFilepanChange}
                          />
                          <PictureAsPdfOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                      <Button
                        size="small"
                        variant="contained"
                        component={"a"}
                        onClick={() => {
                          data.PanImg || panImage
                            ? window.open(
                              panImage
                                ? store.getState().globalurl.attachmentUrl +
                                panImage
                                : store.getState().globalurl.attachmentUrl +
                                data.PanImg,
                              "_blank"
                            )
                            : toast.error("Please Upload File");
                        }}
                      >
                        PAN Image View
                      </Button>
                      {/* GSTimage */}
                      <Tooltip title="GST Upload">
                        <IconButton
                          size="small"
                          color="warning"
                          aria-label="upload picture"
                          component="label"
                        >
                          <input
                            hidden
                            accept="all/*"
                            type="file"
                            onChange={getFilegstChange}
                          />
                          <PictureAsPdfOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                      <Button
                        size="small"
                        variant="contained"
                        component={"a"}
                        onClick={() => {
                          data.GstImg || gstImage
                            ? window.open(
                              gstImage
                                ? store.getState().globalurl.attachmentUrl +
                                gstImage
                                : store.getState().globalurl.attachmentUrl +
                                data.GstImg,
                              "_blank"
                            )
                            : toast.error("Please Upload File");
                        }}
                      >
                        GST Image View
                      </Button>

                      <LoadingButton
                        color="secondary"
                        variant="contained"
                        type="submit"
                        loading={isLoading}
                      >
                        Save
                      </LoadingButton>

                      <Button
                        color="warning"
                        variant="contained"
                        onClick={() => {
                          // navigate("/Apps/TR243/Party");
                          setScreen(0);
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </>
                ) : (
                  false
                )}
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
      {show == "4" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={DefaultInitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                DefaultFnsave(values);
              }, 100);
            }}
            //validationSchema={validationSchema4}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                {!isPartyDeaultLoading ? (
                  <>
                    <Box
                      display="grid"
                      gap={formGap}
                      padding={1}
                      gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                      // gap="30px"
                      sx={{
                        "& > div": {
                          gridColumn: isNonMobile ? undefined : "span 2",
                        },
                      }}
                    >
                      {CompanyAutoCode == "Y" ? (
                        <TextField
                          name="code"
                          type="text"
                          id="code"
                          label="Code"
                          variant="standard"
                          placeholder="Auto"
                          focused
                          // required
                          value={values.code}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.code && !!errors.code}
                          helperText={touched.code && errors.code}
                          sx={{
                            backgroundColor: "#ffffff", // Set the background to white
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                            },
                          }}
                          InputProps={{ readOnly: true }}
                        // autoFocus
                        />
                      ) : (
                        <TextField
                          name="code"
                          type="text"
                          id="code"
                          label={
                            <>
                              Code
                              <span style={{ color: "red", fontSize: "20px" }}>
                                *
                              </span>
                            </>
                          }
                          variant="standard"
                          focused
                          // required
                          value={values.code}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.code && !!errors.code}
                          helperText={touched.code && errors.code}
                          sx={{
                            backgroundColor: "#ffffff", // Set the background to white
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                            },
                          }}
                          autoFocus
                        />
                      )}
                      <TextField
                        name="name"
                        type="text"
                        id="name"
                        label={
                          <>
                            Name
                            {/* <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span> */}
                          </>
                        }
                        variant="standard"
                        focused
                        value={values.name}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.name && !!errors.name}
                        helperText={touched.name && errors.name}
                        sx={{
                          backgroundColor: "#ffffff", // Set the background to white
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                          },
                        }}
                        InputProps={{
                          inputProps: {
                            readOnly: true,
                          },
                        }}
                        // required
                        autoFocus={CompanyAutoCode == "Y"}
                      />
                      <OrderItemAutocomplete
                        id="Product"
                        name="Product"
                        label="Default Product"
                        variant="outlined"
                        value={values.Product}
                        onChange={(newValue) => {
                          setFieldValue("Product", newValue);
                          console.log(newValue, "--newvalue Product");
                          console.log(newValue.RecordID, "Product RecordID");
                        }}
                        error={!!touched.Product && !!errors.Product}
                        helperText={touched.Product && errors.Product}
                        // url={`${listViewurl}?data={"Query":{"AccessID":"2137","ScreenName":"Product","Filter":"parentID='${CompanyID}'","Any":""}}`}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2137","ScreenName":"Product","Filter":"CompanyID='${CompanyID}' AND ItemsDesc ='Product'","Any":"","VerticalLicense":"${Subscriptionlastthree}"}}`}
                      />
                      <TextField
                        name="defaultDelivery"
                        label="Default Delivery Charges"
                        variant="standard"
                        type="number"
                        focused
                        value={values.defaultDelivery}
                        // required
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={
                          !!touched.defaultDelivery && !!errors.defaultDelivery
                        }
                        helperText={
                          touched.defaultDelivery && errors.defaultDelivery
                        }
                        sx={{
                          backgroundColor: "#ffffff",
                        }}
                        InputProps={{
                          inputProps: {
                            style: { textAlign: "right" },
                          },
                        }}
                      // autoFocus
                      />
                      {/* <TextField
                        name="DefaultPaymentMode"
                        label="Default Payment Mode"
                        variant="standard"
                        type="text"
                        focused
                        value={values.DefaultPaymentMode}
                        // required
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={
                          !!touched.DefaultPaymentMode &&
                          !!errors.DefaultPaymentMode
                        }
                        helperText={
                          touched.DefaultPaymentMode &&
                          errors.DefaultPaymentMode
                        }
                        sx={{
                          backgroundColor: "#ffffff",
                        }}
                      /> */}

                      <TextField
                        select
                        label="Default Payment Mode"
                        id="DefaultPaymentMode"
                        name="DefaultPaymentMode"
                        value={values.DefaultPaymentMode}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e); // update form state (Formik)
                          sessionStorage.setItem(
                            "DefaultPaymentMode",
                            e.target.value
                          ); // save to sessionStorage
                        }}
                        focused
                        variant="standard"
                      >
                        <MenuItem value="COD">Cash On Delivery</MenuItem>
                        <MenuItem value="UPI">UPI</MenuItem>
                        <MenuItem value="Others">Others</MenuItem>
                      </TextField>
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="end"
                      padding={1}
                      gap="20px"
                    >
                      <LoadingButton
                        color="secondary"
                        variant="contained"
                        type="submit"
                        loading={isLoading}
                      >
                        Save
                      </LoadingButton>

                      <Button
                        color="warning"
                        variant="contained"
                        onClick={() => {
                          // navigate("/Apps/TR243/Party");
                          setScreen(0);
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </>
                ) : (
                  false
                )}
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}


      {show == "5" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={InitialValue}
            // validationSchema={validationSchema2}
            enableReinitialize={true}
          // onSubmit={(values, { resetForm, setFieldValue }) => {
          //   setTimeout(() => {
          //     FnAttachment(values, resetForm, false, setFieldValue);
          //   }, 100);
          // }}
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleSubmit,
              handleChange,
              setFieldValue,
              resetForm,
            }) => (
              <form
                onSubmit={handleSubmit}
                onReset={() => {
                  selectCellRowData({ rowData: {}, mode: "A", field: "" });
                  resetForm();
                }}
              >


                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >

                  {/* <FormControl sx={{ gap: formGap }}> */}
                  <TextField
                    fullWidth
                    variant="standard"
                    type="text"
                    id="code"
                    name="code"
                    value={values.code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    label="Code"
                    focused
                    InputProps={{
                      readOnly: true
                    }}
                  />

                  <TextField
                    fullWidth
                    variant="standard"
                    type="text"
                    id="name"
                    name="name"
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    label="Name"
                    focused
                    InputProps={{
                      readOnly: true
                    }}
                  />
                  {/* </FormControl> */}
                </Box>

                <Box
                  padding={1}
                  m="5px 0 0 0"
                  // height="50vh"
                  height={dataGridHeightExplore}
                  sx={{
                    "& .MuiDataGrid-root": {
                      border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      borderBottom: "none",
                    },
                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#D3D3D3",
                      color: "", // Color for even rows
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rows={explorelistViewData}
                    columns={columns}
                    disableSelectionOnClick
                    getRowId={(row) => row.RecordID}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) =>
                      setPageSize(newPageSize)
                    }
                    onCellClick={(params) => {
                      selectCellRowData({
                        rowData: params.row,
                        mode: "E",
                        field: params.field,
                      });
                    }}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    components={{
                      Toolbar: Employee,
                    }}
                    onStateChange={(stateParams) =>
                      setRowCount(stateParams.pagination.rowCount)
                    }
                    loading={exploreLoading}
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                  />
                </Box>



              </form>
            )}
          </Formik>
          <Box display="flex" justifyContent="space-between" padding={1}>

            <Box>
              <Typography fontWeight={600} fontSize={15} lineHeight={1} mb={1} ml={0.5}>
                Actions Guide
              </Typography>
              <Box display="flex"
                flexDirection="row"
                gap="15px"
                sx={{ overflowY: "auto" }}>
                <Chip
                  icon={<VisibilityIcon color="primary" />}
                  label="Open Document"
                  variant="outlined"
                />
              </Box>
            </Box>
            <Box display="flex" justifyContent="space-between" padding={1}>
              <Button
                color="warning"
                variant="contained"
                onClick={() => {
                  setScreen("0");
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Paper>
      ) : (
        false
      )}
    </React.Fragment>
  );
};

export default Editvendor;
